// Leads Boot Camp video catalog.
// Use Publitio "Share URL" links (ending in .html) — the direct .mp4 files do
// not stream reliably, so the player embeds the .html page via an iframe.
// Chapter, order, and title are derived from the filename pattern
// `NNN-Title-With-Hyphens.html` (e.g. 203-The-Circle-of-Life.html -> Chapter 2,
// Video 3, "The Circle of Life"). First digit = chapter, last two digits = order.

const BASE = 'https://media.publit.io/file/ProsperityWebApp/LeadsDivision';

const VIDEO_URLS = [
  // Chapter 1
  `${BASE}/101-Introduction-by-AJ.html`,
  `${BASE}/102-Why-Life-Insurance.html`,
  `${BASE}/103-1099-vs-W2.html`,
  `${BASE}/104-Bootcamp-Expectations.html`,
  // Chapter 2
  `${BASE}/201-Chapter-overview.html`,
  `${BASE}/202-Developing-a-Winners-Mindset.html`,
  `${BASE}/203-The-Circle-of-Life.html`,
  `${BASE}/204-Zoom-Culture-Rules.html`,
  `${BASE}/205-How-To-Structure-your-day.html`,
  `${BASE}/206-Commont-Pitfalls-and-How-to-Avoid-Them.html`,
  // Chapter 3
  `${BASE}/301-Chapter-Overview.html`,
  `${BASE}/302-The-Customer-Journey.html`,
];

const CHAPTER_TITLES = {
  1: 'Chapter 1',
  2: 'Chapter 2',
  3: 'Chapter 3',
};

function parseVideo(url) {
  const filename = url.split('/').pop() || '';
  const base = filename.replace(/\.[^.]+$/, '');
  const dashIndex = base.indexOf('-');

  if (dashIndex === -1) {
    return { number: null, chapter: 0, order: 0, title: base, url };
  }

  const numberPart = base.slice(0, dashIndex);
  const slug = base.slice(dashIndex + 1);
  const number = Number.parseInt(numberPart, 10);
  const title = slug.replace(/-/g, ' ').trim() || base;

  if (Number.isNaN(number)) {
    return { number: null, chapter: 0, order: 0, title, url };
  }

  return {
    number,
    chapter: Math.floor(number / 100),
    order: number % 100,
    title,
    url,
  };
}

export const bootCampVideos = VIDEO_URLS.map(parseVideo).sort(
  (a, b) => (a.number ?? 0) - (b.number ?? 0),
);

export const bootCampChapters = (() => {
  const map = new Map();
  for (const video of bootCampVideos) {
    if (!map.has(video.chapter)) map.set(video.chapter, []);
    map.get(video.chapter).push(video);
  }
  return [...map.entries()]
    .sort((a, b) => a[0] - b[0])
    .map(([chapter, videos]) => ({
      chapter,
      title: CHAPTER_TITLES[chapter] || `Chapter ${chapter}`,
      videos,
    }));
})();

export const bootCampVideoCount = bootCampVideos.length;
